import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { CustomDirectivesModule } from 'src/app/shared/custom-directives-module/custom-directives.module';
import { RicercaGenericaAnagraficheModule } from '../ricerca-generica-anagrafiche/ricerca-generica-anagrafiche.module';
import { FabbricatiFormComponent } from './dialogs/form/form.component';
import { FabbricatiRoutingModule } from './fabbricati-routing.module';
import { FabbricatiComponent } from './fabbricati.component';
import { PreesistenzaComponent } from './preesistenza/preesistenza.component';
import { SearchComponent } from './search/search.component';
import { SommeAssicurateModule } from '../polizze/somme-assicurate/somme-assicurate.module';


@NgModule({
  declarations: [FabbricatiComponent, FabbricatiFormComponent, PreesistenzaComponent, SearchComponent],
  imports: [
    CommonModule,
    FabbricatiRoutingModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
    RicercaGenericaAnagraficheModule,
    CustomDirectivesModule,
    SommeAssicurateModule,
  ],
  exports: [
    PreesistenzaComponent,
  ]
})
export class FabbricatiModule { }
